// extracted by mini-css-extract-plugin
export var buttonContainer = "_82-1";
export var fontSizeSelect = "_82-3";
export var formatSelect = "_82-2";
export var formats = "_82-4";
export var hidden = "_82-5";
export var icon = "_82-6";
export var select = "_82-0";